import React, { ReactElement, useCallback } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { ContentType } from 'common/src/commentThread/types'
import { ContentPath } from 'common/src/ContentPath'
import { annotatedContentProviderAtom } from 'magic-text-box-lexical/src/atoms/annotations/annotatedContentProvider'
import { annotatedContentMapAtom } from 'magic-text-box-lexical/src/atoms/annotations/annotatedContentMap'
import { CommentReplyDraft } from '@/components/ContentCommentThread/ReadComment/CommentReplyDraft/CommentReplyDraft'
import { RepliedCommentInfo } from '@/hooks/useClearCommentNotificationPrompt'

// Renders the AI reply draft inside the outline annotation panel. The panel
// keeps its own comment list (read from annotatedContentMapAtom), separate from
// the notecard/PP thread-refresh path, so after a reply is posted we reload the
// annotated-content map so the new reply shows without a page refresh.
export const OutlineCommentReplyDraft: React.FC<{
    commentId: string
    courseName: string
    contentType: ContentType
    contentId: string
    contentPath: ContentPath
    comment?: RepliedCommentInfo
}> = (props): ReactElement => {
    const annotatedContentProvider = useRecoilValue(
        annotatedContentProviderAtom
    )
    const setAnnotatedContentMap = useSetRecoilState(annotatedContentMapAtom)

    const onPosted = useCallback(async (): Promise<void> => {
        const map = await annotatedContentProvider.loadAnnotatedContentMap()
        setAnnotatedContentMap(map)
    }, [annotatedContentProvider, setAnnotatedContentMap])

    return <CommentReplyDraft {...props} onPosted={onPosted} />
}
